// App library
import ContentLoader from "./modules/content";

var Gitguide = function () {
  // @todo: Remove contextPath code when context path is removed from CMS
  var contextPath = "";
  if (
    "undefined" !== typeof window &&
    "undefined" !== typeof window.HTTP_PREFIX
  ) {
    contextPath = window.HTTP_PREFIX;
  }

  // Initialize microsite content
  var cl = new ContentLoader(contextPath);
  cl.getContent(contextPath);
};

// Load edit mode

Gitguide();
